var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRrrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 11.2659L6.34525 9.03312C6.89845 7.90535 8.52438 7.96043 9 9.12305C9.47562 10.2857 11.1015 10.3407 11.6548 9.21298L12.75 6.98019M9 15.873C6.1877 15.873 4.78155 15.873 3.79581 15.1569C3.47745 14.9256 3.19748 14.6456 2.96619 14.3272C2.25 13.3415 2.25 11.9353 2.25 9.12305C2.25 6.31075 2.25 4.9046 2.96619 3.91885C3.19748 3.6005 3.47745 3.32053 3.79581 3.08923C4.78155 2.37305 6.1877 2.37305 9 2.37305C11.8123 2.37305 13.2184 2.37305 14.2042 3.08923C14.5225 3.32053 14.8025 3.6005 15.0338 3.91885C15.75 4.9046 15.75 6.31075 15.75 9.12305C15.75 11.9353 15.75 13.3415 15.0338 14.3272C14.8025 14.6456 14.5225 14.9256 14.2042 15.1569C13.2184 15.873 11.8123 15.873 9 15.873Z",
    stroke: "#F6F6F6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRrrIcon);
export default __webpack_public_path__ + "static/media/rrrIcon.27c8f621f9f803661c6c3ce8ad065e2c.svg";
export { ForwardRef as ReactComponent };